import { Link } from "@msuite/ui/link";
import { useTranslation } from "@msuite/ui/localization";
import { cn } from "@msuite/ui/utils";

export function LegalFooter() {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div
			className={cn(
				"bottom-0 left-0 absolute flex justify-between px-4 py-2 w-full *:text-primaryGray-500! text-xs",
			)}
		>
			<p>{new Date().getFullYear()} &copy; Suite</p>
			<div className="flex flex-row gap-8 **:text-primary-500! opacity-50">
				<Link href="/imprint">{t("legal.imprint")}</Link>
				<Link href="/privacy">{t("legal.privacy_policy")}</Link>
				<Link href="/terms">{t("legal.terms_and_conditions")}</Link>
			</div>
		</div>
	);
}
